<template>
  <table id="stats">
    <thead>
      <tr>
        <th>#</th>
        <th style="max-width: 50px !important">{{ $t('ranking.character') }}</th>
        <th>{{ $t('ranking.clan') }}</th>
        <th>
          <span class="_pk">{{ $t('ranking.pk') }}</span> /
          <span class="_pvp">{{ $t('ranking.pvp') }}</span>
        </th>
        <th>{{ $t('ranking.status') }}</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(player, i) in top" :key="i">
        <tr>
          <td class="text-center">{{ player.rank }}</td>
          <td>
            <span
              :class="{ male: player.sex === '0', female: player.sex === '1' }"
              class="tooltip fix-wrap-char-title bold"
              translate="no"
              >{{ player.char_name }}
              <span class="tooltiptext"
                >{{ $t('ranking.online_time') }} {{ get_online_time(player.onlinetime) }}</span
              >
            </span>
            <hr />
            <span style="font-size: 0.8em" translate="no"
              >{{ player.class_name }}, {{ player.level }}</span
            >
          </td>
          <td class="text-center fix-wrap-clan-title">
            {{ player.clan_name }}
          </td>
          <td class="text-center bold">
            <span class="_pk">{{ comma_seperated(player.pkkills) }}</span>
            <hr />
            <span class="_pvp">{{ comma_seperated(player.pvpkills) }}</span>
          </td>
          <td :class="player.online === '0' ? 'ico_status_off' : 'ico_status_on'"></td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PK',
  props: {
    top: {
      type: Object,
      required: true,
    },
  },
  methods: {
    get_online_time(time) {
      let online_time_h;
      let x = time / 60 / 60 - 0.5;
      if (x <= 0) {
        online_time_h = 0;
      } else {
        online_time_h = Math.round(x);
      }
      let online_time_m = Math.round((time / 60 / 60 - online_time_h) * 60);
      return `${online_time_h} ${this.$t('ranking.hrs')} ${online_time_m} ${this.$t(
        'ranking.min'
      )}`;
    },
    comma_seperated(num) {
      return Number(num).toLocaleString('en-US');
    },
  },
};
</script>

<style scoped></style>
